const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    loadAllSuggestions: { start: (detail) => { loadAllSuggestions(detail) } },
}

const SUGGESTION_ALL_QUESTIONS = [  
    "Which item–provider pairs have the best ROI?",
    "Which item–customer pairs have the best ROI?",
]

function getGeneralQuestions(type) {

    if (type === "suggestionAll") {
        return SUGGESTION_ALL_QUESTIONS
    }

}

function loadAllSuggestions(detail) {
    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: Suggestion
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: All Suggestions
                </div>
            </div>

        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of all suggestions
                </div>
            </div>
        </div>
    `;


    chat.start(
        {
            "dest": "chat",
            "act": "quickview",
            "actQuickview": "show",
            "type": "suggestionAll",
            "entity": "suggestion",
            "question": detail.question ?? "",
            "generalQuestions": getGeneralQuestions("suggestionAll"),
            "cardWarning": cardWarning,
            "ev": detail.ev
        }
   )
}